import { MealFormType, MealItemType, SectionType } from 'models/production-report.model';
import { ActiveType } from 'models/vendors.model';
import { createContext, useContext } from 'react';

export type ProductionReportContextType = {
  sections: SectionType[];
  setSections: (restaurants: SectionType[]) => void;
  activeSection: SectionType;
  setActiveSection: (restuarant: SectionType) => void;
  loading: boolean;
  setLoading: (loading: boolean) => void;
  isBackLink: boolean;
  setIsBackLink: (value: boolean) => void;
  backLinkTitle: string;
  setBackLinkTitle: (value: string) => void;
  mealFormData: MealFormType[];
  setMealFormData: (meal: MealFormType[]) => void;
  active: ActiveType | null;
  setActive: (item: ActiveType | null) => void;
  selectedMeals: MealItemType[];
  setSelectedMeals: (meals: MealItemType[]) => void;
};

export const ProductionReportContext = createContext({} as ProductionReportContextType);

const useProductionReportContext = () => {
  const context = useContext(ProductionReportContext);
  return context;
};

export default useProductionReportContext;
